import { motion } from "framer-motion";
import { RefreshCw, TrendingUp, CloudCheck, Database } from "lucide-react";

const capabilities = [
  {
    value: "CRM / ERP",
    label: "Đồng bộ dữ liệu vận hành từ website về hệ thống nội bộ một cách liền mạch.",
    icon: Database,
  },
  {
    value: "GA4 / Pixel",
    label: "Thiết lập tracking marketing chuẩn ngay từ đầu để đo lường chính xác hiệu quả chuyển đổi.",
    icon: TrendingUp,
  },
  {
    value: "Cloud / SSL",
    label: "Tối ưu hạ tầng tốc độ cao cùng các lớp bảo mật cần thiết cho quá trình vận hành lâu dài.",
    icon: CloudCheck,
  },
  {
    value: "Mở rộng linh hoạt",
    label: "Sẵn sàng tích hợp API và nâng cấp tính năng theo từng giai đoạn phát triển của doanh nghiệp.",
    icon: RefreshCw,
  },
];

export default function SectionBannerStore() {
  return (
    <section className="relative overflow-hidden bg-white py-10 sm:py-12">
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <motion.div
          className="overflow-hidden rounded-[28px] border border-red-100 bg-[linear-gradient(180deg,#fffdfd_0%,#fff5f5_100%)] shadow-[0_24px_60px_rgba(127,29,29,0.08)]"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="px-5 py-7 sm:px-7 sm:py-8 lg:px-10 lg:py-10">
            <div className="grid gap-8 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.35fr)] lg:items-start">
              <div className="max-w-[620px] text-left">
                <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
                  Giải pháp tích hợp sẵn
                </span>

                <h2 className="mt-4 text-left text-[25px] font-semibold leading-[1.18] text-[#2f1a1a] sm:text-[30px] lg:text-[34px]">
                  Khả Năng Tích Hợp & Nâng Cấp Hệ Thống
                </h2>

                <p className="mt-4 max-w-[560px] text-left text-[15px] leading-7 text-slate-600 sm:text-[15.5px]">
                  Chọn một giao diện nền tảng chỉ là bước khởi đầu. Tại TrioCore, chúng tôi hỗ trợ doanh
                  nghiệp mở rộng hệ thống không giới hạn, từ dữ liệu nội bộ, tracking marketing đến hạ tầng
                  vận hành bảo mật.
                </p>
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                {capabilities.map(({ value, label, icon: Icon }, index) => (
                  <motion.div
                    key={value}
                    className="rounded-[22px] border border-red-100 bg-white p-5 text-left shadow-[0_12px_30px_rgba(127,29,29,0.05)]"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.08, duration: 0.45 }}
                  >
                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                      <Icon size={24}  />
                    </div>

                    <div className="mt-4 text-[17px] font-semibold leading-6 text-[#2f1a1a]">{value}</div>

                    <p className="mt-2 text-[13px] leading-6 text-slate-600">{label}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
